import { render } from "./AddEditInternetPointModal.vue?vue&type=template&id=8f8e983e&scoped=true"
import script from "./AddEditInternetPointModal.vue?vue&type=script&lang=js"
export * from "./AddEditInternetPointModal.vue?vue&type=script&lang=js"

import "./AddEditInternetPointModal.vue?vue&type=style&index=0&id=8f8e983e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8e983e"]])

export default __exports__